const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgroIconBrown26(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.86 55.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.58,0c-2.12,0-4.29.52-6.29,1.51-3.2,1.58-6.8,2.49-11.02,2.77-7.06.47-13.81,3.7-19.01,9.1C3.44,18.38.53,24.82.06,31.52c-.46,6.58,1.51,12.66,5.53,17.12,4.24,4.71,10.27,7.3,16.96,7.3,7.37,0,14.79-3.19,20.34-8.75,5.16-5.16,8.24-11.79,8.69-18.67.27-4.16,1.17-7.74,2.76-10.95,2.51-5.07,1.83-10.84-1.7-14.37C50.58,1.14,47.71,0,44.58,0h0Zm-4.98,19.6c-.21,1.36-.36,2.76-.45,4.19-.3,4.64-2.65,9.47-6.44,13.26-5.85,5.85-11.98,6.49-14.34,6.49-1.22,0-2.94-.16-4.18-.92l-.65-.4-.37-.66c-1.6-2.84-1.19-11.32,5.33-18.08,3.84-3.98,8.78-6.44,13.56-6.76,1.45-.1,2.87-.25,4.22-.45l3.93-.6-.6,3.93Z",
    style: {
      fill: "#a26128"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.14,25.95c-5.22,5.42-5.2,11.74-4.4,13.16.41.25,1.25.44,2.39.44,2.71,0,7.06-1.09,11.05-5.07,2.97-2.97,4.81-6.71,5.03-10.25.08-1.37.23-2.7.43-4-1.3.2-2.63.34-4.02.43-3.66.25-7.48,2.17-10.48,5.29h0Z",
    style: {
      fill: "#a26128"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgroIconBrown26);
export default __webpack_public_path__ + "static/media/agro-icon-brown-26.421dff78d1d9d57bb4a7f62edcad60af.svg";
export { ForwardRef as ReactComponent };